import { render } from "./HelpFAQRequest.vue?vue&type=template&id=cc8c0df0"
import script from "./HelpFAQRequest.vue?vue&type=script&lang=js"
export * from "./HelpFAQRequest.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__